const { chunk, pick } = require('lodash');

const docToData = (doc) => {
  return { ...pick(doc, ['id', 'ref']), ...doc.data() };
};

const getDocumentData = async (ref) => {
  const doc = await ref.get();
  return doc.exists ? docToData(doc) : null;
};

const getCollectionData = async (ref) => {
  return (await ref.get()).docs.map(docToData);
};

const batch = async (db, data, f, chunkSize = 500) => {
  return await chunk(data, chunkSize).reduce(async (x, data, i) => {
    const prevs = await x;

    const batch = db.batch();
    const refs = data.map((_, i2) => f(batch, _, i * chunkSize + i2));
    await batch.commit();
    return [...prevs, ...refs];
  }, Promise.resolve([]));
};

const getAllCollectionDataByChunk = async (_ref, limit = 10000, lastDoc = null, prevs = []) => {
  const ref = lastDoc != null ? _ref.startAfter(lastDoc) : _ref;
  const { docs } = await ref.limit(limit).get();
  const [nextLastDoc] = docs.slice(-1);
  const all = [...prevs, ...docs.map(docToData)];
  // console.info(all.length);
  return nextLastDoc == null ? all : await getAllCollectionDataByChunk(ref, limit, nextLastDoc, all);
};

const processAllCollectionData = async (_ref, process, limit = 1000, count = 0, lastDoc = null) => {
  const ref = lastDoc != null ? _ref.startAfter(lastDoc) : _ref;
  const { docs } = await ref.limit(limit).get();
  const [nextLastDoc] = docs.slice(-1);
  const items = docs.map(docToData);
  await process(items, count, count + items.length);
  if(nextLastDoc != null) await processAllCollectionData(ref, process, limit, count + items.length, nextLastDoc);
};

module.exports = {
  docToData,
  getDocumentData,
  getCollectionData,
  getAllCollectionDataByChunk,
  batch,
  processAllCollectionData,
};
